//api path 
const subscribersSendVerificationMail = window.customerData?.mobileApiEntryPoint ? (window.customerData?.mobileApiEntryPoint + "/subscribers/send-verification-mail") : null;
const subscribersVerifyEmail = window.customerData?.mobileApiEntryPoint ? (window.customerData?.mobileApiEntryPoint + "/subscribers/verify-email") : null;

const codeInputs = document.querySelectorAll('.code-input');
const verify_email = document.getElementById('verify_email');
const errorElement = document.getElementById('errorEmailverifyOtp');
const successElement = document.getElementById('successEmailVerifyOTP');

const UNIT_MAP = {
  second: 'second', seconds: 'second', sec: 'second', secs: 'second', s: 'second',
  minute: 'minute', minutes: 'minute', min: 'minute', mins: 'minute', m: 'minute',
  hour: 'hour', hours: 'hour', hr: 'hour', hrs: 'hour', h: 'hour'
};

function extractDurationFromMessage(message) {
  if (!message || typeof message !== 'string') return null;
  // tolerant regex — picks number and the following word at end of string
  const m = message.match(/for\s+([\d.]+)\s*([^\s.?!,]+)\s*$/i);
  if (!m) return null;
  return { value: Number(m[1]), rawUnit: m[2].toLowerCase() };
}

function localizedDuration(value, rawUnit, locale) {
  const unit = UNIT_MAP[rawUnit] || null;
  if (!unit) return `${value} ${rawUnit}`; // fallback if unknown unit

  try {
    // Use Intl.NumberFormat with style: 'unit' so plurals/localization are handled
    const nf = new Intl.NumberFormat(locale || undefined, {
      style: 'unit',
      unit,
      unitDisplay: 'long'
    });
    return nf.format(value);
  } catch (e) {
    return `${value} ${rawUnit}`; // fallback
  }
}

//  Open Popup
function openEmailVerifyPopup() {
  const popup = document.getElementById('email_verify_popup');
  if(window.location.href.includes('account')){
    document.getElementById('before_continue_verify').classList.add('hidden')
  }
  if (popup) {
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }
}

// Handle Resend Click
let otpNextGenerationAt = 0;
let timerInterval = null;

async function handleResendClick() {
  const now = Date.now();

  if (now < otpNextGenerationAt) {
    console.log("⏳ Please wait before resending.");
    return;
  }

  const result = await generateEmailVerifyOtp();

  if (result?.otpNextGenerationAt) {
    otpNextGenerationAt = result.otpNextGenerationAt;
    startCooldownTimer(otpNextGenerationAt);
  }
}

async function generateEmailVerifyOtp() {
  codeInputs.forEach(input => input.value = '');

  const errorElement = document.getElementById('errorEmailverifyOtp');
  const successElement = document.getElementById('successEmailVerifyOTP');

  try {

    const formData = new FormData();
    const gbToken = await updateGBToken();
    const response = await fetch(subscribersSendVerificationMail, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${gbToken}`,
      },
      body: formData,
    });

    // Hide success initially
    successElement.textContent = '';
    successElement.classList.add('hidden');

    // Handle non-200 responses
    // if (!response.ok) {
    //   errorElement.classList.remove('hidden');
    //   const errorData = await response.json();
    //   errorElement.textContent = errorData.message;
    //   // Optional: disable resend button here
    //   return;
    // }

     if (!response.ok) {
      errorElement.classList.remove('hidden');

      // Try to get JSON message, but tolerate plain text
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        const text = await response.text();
        errorData = { message: text };
      }

      const errorMessage = String(errorData?.message || '');

      if (response.status === 429) {
        const dur = extractDurationFromMessage(errorMessage);

        // base translation string from Liquid (should include {duration})
        const base = window.emailVerificationRes?.resend_otp_error || 'You cannot generate another OTP for {duration}';

        if (dur) {
          const htmlLang = document.documentElement.lang; // gets value from <html lang="...">
          const locale = htmlLang || navigator.language || 'en';
          const formatted = localizedDuration(dur.value, dur.rawUnit, locale);

          // Replace common placeholder variants
          const finalMessage = base.replace(/\{duration\}|\%\{duration\}/, formatted);

          errorElement.textContent = finalMessage;
          return;
        }

        // If parsing failed, show the base string with raw message appended or substituted
        const fallback = base.includes('{duration}')
          ? base.replace(/\{duration\}|\%\{duration\}/, errorMessage)
          : `${base} — ${errorMessage}`;

        errorElement.textContent = fallback;
        return;
      }

      if (response.status === 400) {
        if (errorMessage.toLowerCase().includes('invalid otp!')) {
          console.log('User entered an invalid OTP.');
          errorElement.textContent = window.emailVerificationRes.inv_otp || "Invalid OTP!";

        } else if (errorMessage.toLowerCase().includes('invalid jwt token')) {
          console.log('Invalid JWT Token message');
          errorElement.textContent = window.emailVerificationRes.inv_token || "Invalid JWT Token";

        } else if (errorMessage.toLowerCase().includes('jwt expired')) {
          console.log("JWT expired message");
          errorElement.textContent = window.emailVerificationRes.jwt_expired || "JWT expired";

        } else {
          errorElement.textContent = errorMessage;
        }
      }
      // Other status codes: just show the message or a generic fallback
      errorElement.textContent = errorMessage || 'Something went wrong. Please try again.';
      return;
    }

    // Success
    const result = await response.json();

    errorElement.textContent = '';
    errorElement.classList.add('hidden');

    successElement.textContent = window.emailVerificationRes.otpSent_txt || result.message;
    successElement.classList.remove('hidden');

    setTimeout(() => successElement.classList.add('hidden'), 5000);

    return result;

  } catch (error) {
    console.log('Error generating OTP:', error);

    successElement.textContent = '';
    successElement.classList.add('hidden');

    errorElement.textContent = error.message || 'Something went wrong. Please try again.';
    errorElement.classList.remove('hidden');

    return null;
  }
}

function startCooldownTimer(unixTimestampMs) {
  const resendLink = document.getElementById('resendLink');
  const resendTimer = document.getElementById('resendTimer');

  // Disable resend link
  resendLink.style.pointerEvents = 'none';
  resendLink.style.opacity = 0.5;

  // Clear any previous interval
  if (timerInterval) clearInterval(timerInterval);

  timerInterval = setInterval(() => {
    const now = Date.now();
    const remaining = Math.ceil((unixTimestampMs - now) / 1000);

    if (remaining <= 0) {
      clearInterval(timerInterval);
      resendTimer.textContent = ''; // Clear the timer text
      resendLink.style.pointerEvents = 'auto';
      resendLink.style.opacity = 1;
    } else {
      resendTimer.textContent = `(${remaining}s)`;
    }
  }, 1000);
}


// if (verify_email) {
//   verify_email.addEventListener('click', async (event) => {
//     event.preventDefault(); // Prevent default form submission

//     const codeInputs = document.querySelectorAll('.code-input');
//     const otp = Array.from(codeInputs).map(input => input.value).join('');

//     const email_verif_pop_up = document.getElementById('email_verif_pop_up');
//     const emailVerifiedSuccessMsg = document.getElementById('email_verifed_success_msg');
//     // const success_checkmark = document.getElementById('success_checkmark');

//     const email_warning_msg = document.getElementById('email_warning_msg');
//     const warning_checkmark = document.getElementById('warning_checkmark');
//     const email_warning_btn = document.getElementById('email_warning_btn');

//     const errorElement = document.getElementById('errorEmailverifyOtp');
//     const successElement = document.getElementById('successEmailVerifyOTP');

//     if (errorElement) errorElement.textContent = '';
//     if (successElement) successElement.textContent = '';
//     if (errorElement) errorElement.classList.add('hidden');
//     if (successElement) successElement.classList.add('hidden');

//     // Validation
//     if (!otp) {
//       if (errorElement) {
//         // errorElement.textContent = 'Please enter the verification code.';
//         errorElement.classList.remove('hidden');
//       }
//       return;
//     }

//     if (otp.length < 6) {
//       if (errorElement) {
//         // errorElement.textContent = 'Please enter a complete 6-digit verification code.';
//         errorElement.classList.remove('hidden');
//       }
//       return;
//     }

//     try {
//       const gbToken = await updateGBToken();
//       const response = await fetch(subscribersVerifyEmail, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${gbToken}`,
//         },
//         body: JSON.stringify({ otp }),
//       });

//       if (!response.ok) {
//         const result = await response.json().catch(() => ({}));
//         const errorMsg = result.message || `Verification failed (status: ${response.status})`;
//         throw new Error(errorMsg);
//       }

//       const result = await response.json();

//       if (successElement) {
//         // successElement.textContent = result.message || 'Email verified successfully!';
//         successElement.classList.remove('hidden');
//         const popup = document.getElementById('email_verify_popup');
//         if (popup) {
//           popup.classList.add('active_email_verified_success');
//         }
//       }

//       if (email_warning_msg) email_warning_msg.classList.add('hidden');
//       if (warning_checkmark) warning_checkmark.classList.add('hidden');
//       if (email_warning_btn) email_warning_btn.classList.add('hidden');
//       if (email_verif_pop_up) email_verif_pop_up.classList.add('hidden');
//       //show the success popup and remove otp section
//       document.getElementById('email_varification_pop_up').classList.add('hidden')
//       document.getElementById('email_verified_success').classList.remove('hidden')
//       document.querySelectorAll('.email_verify_popup .modal_body').classList.add('dark_mode')

//       // if (success_checkmark) success_checkmark.classList.remove('hidden');
//       // if (emailVerifiedSuccessMsg) {
//       //   emailVerifiedSuccessMsg.classList.remove('hidden');
//       //   emailVerifiedSuccessMsg.textContent = result.message;
//       // }

//       // closeEmailVerifyPopup();

//       const subscriber = await subscriberMe();
//       console.log("window.subscriberMeResponse", subscriber);

//       const verifyedEmail = document.getElementById('verified_email');
//       const verifyEmail = document.getElementById('verify_email');

//       if (subscriber && subscriber.verifiedAccount === true) {
//         if (verifyEmail) verifyEmail.classList.add('hidden');
//         if (verifyedEmail) verifyedEmail.classList.remove('hidden');
//         console.log("Email is verified, showing verified message.");
//       } else {
//         if (verifyEmail) verifyEmail.classList.remove('hidden');
//         // if (verifyedEmail) verifyedEmail.classList.add('hidden'); // optional
//         console.log("Email is not verified, showing verify button.");
//       }
//       //if user in plan collection page
//       if (window.location.href.includes('collections')) {
//         canProceedToCheckout();
//       }

//       // setTimeout(() => {
//       //   closeEmailVerifyPopup();
//       //   
//       // }, 3000);

//     } catch (error) {
//       console.error('Error verifying email:', error.message);
//       if (errorElement) {
//         errorElement.textContent = error.message ;
//         errorElement.classList.remove('hidden');
//       }
//     }
//   });
// }

if (verify_email) {
  verify_email.addEventListener('click', async (event) => {
    event.preventDefault(); // Prevent default

    // --- local variables only (do not overwrite globals) ---
    const codeInputs = document.querySelectorAll('.code-input');
    const otp = Array.from(codeInputs).map(input => input.value).join('');

    const email_verif_pop_up = document.getElementById('email_verif_pop_up');
    const emailVerifiedSuccessMsg = document.getElementById('email_verifed_success_msg');

    const email_warning_msg = document.getElementById('email_warning_msg');
    const warning_checkmark = document.getElementById('warning_checkmark');
    const email_warning_btn = document.getElementById('email_warning_btn');

    const errorElement = document.getElementById('errorEmailverifyOtp');
    const successElement = document.getElementById('successEmailVerifyOTP');

    // Clear previous messages but don't modify any CSS other than toggling existing classes
    if (errorElement) {
      errorElement.textContent = '';
      errorElement.classList.add('hidden');
    }
    if (successElement) {
      successElement.textContent = '';
      successElement.classList.add('hidden');
    }

    // --- Validation (no CSS changes except showing existing error element) ---
    if (!otp) {
      if (errorElement) {
        // keep original styling, only reveal existing element
        errorElement.classList.remove('hidden');
      }
      return;
    }

    if (otp.length < 6) {
      if (errorElement) {
        errorElement.classList.remove('hidden');
      }
      return;
    }

    try {
      // keep using your existing updateGBToken() and subscribersVerifyEmail variables
      const gbToken = await updateGBToken();
      const response = await fetch(subscribersVerifyEmail, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${gbToken}`,
        },
        body: JSON.stringify({ otp }),
      });

      // Read JSON once and derive a safe error message string
      const result = await response.json().catch(() => ({}));
      const errorMessage = String(result.message || `Verification failed (status: ${response.status})`);
      const errLower = errorMessage.toLowerCase();

      if (!response.ok) {
        // handle known 400 error cases (case-insensitive) without mutating globals
        if (response.status === 400) {
          if (errLower.includes('invalid otp')) {
            if (errorElement) {
              errorElement.textContent = (window.emailVerificationRes && window.emailVerificationRes.inv_otp) || 'Invalid OTP!';
              errorElement.classList.remove('hidden');
            }
            return;
          } else if (errLower.includes('invalid jwt token')) {
            if (errorElement) {
              errorElement.textContent = (window.emailVerificationRes && window.emailVerificationRes.inv_token) || 'Invalid JWT Token';
              errorElement.classList.remove('hidden');
            }
            return;
          } else if (errLower.includes('jwt expired') || errLower.includes('token expired')) {
            if (errorElement) {
              errorElement.textContent = (window.emailVerificationRes && window.emailVerificationRes.jwt_expired) || 'JWT expired';
              errorElement.classList.remove('hidden');
            }
            return;
          }
        }

        // Generic non-OK handling (do not overwrite any global)
        if (errorElement) {
          errorElement.textContent = errorMessage;
          errorElement.classList.remove('hidden');
        }
        return;
      }

      // --- Success path: reveal existing success UI (do not change CSS definitions) ---
      if (successElement) {
        // keep original UI; only toggle pre-existing classes/elements
        successElement.classList.remove('hidden');
        const popup = document.getElementById('email_verify_popup');
        if (popup) popup.classList.add('active_email_verified_success');
      }

      if (email_warning_msg) email_warning_msg.classList.add('hidden');
      if (warning_checkmark) warning_checkmark.classList.add('hidden');
      if (email_warning_btn) email_warning_btn.classList.add('hidden');
      if (email_verif_pop_up) email_verif_pop_up.classList.add('hidden');

      const evPop = document.getElementById('email_varification_pop_up');
      if (evPop) evPop.classList.add('hidden');

      const evSuccess = document.getElementById('email_verified_success');
      if (evSuccess) evSuccess.classList.remove('hidden');

      // querySelectorAll returns NodeList — iterate and use existing 'dark_mode' class if present
      document.querySelectorAll('.email_verify_popup .modal_body').forEach(el => {
        el.classList.add('dark_mode');
      });

      // Update subscriber UI using your existing subscriberMe() call
      const subscriber = await subscriberMe();
      const verifiedEmailEl = document.getElementById('verified_email');
      const verifyEmailEl = document.getElementById('verify_email');

      if (subscriber && subscriber.verifiedAccount === true) {
        if (verifyEmailEl) verifyEmailEl.classList.add('hidden');
        if (verifiedEmailEl) verifiedEmailEl.classList.remove('hidden');
      } else {
        if (verifyEmailEl) verifyEmailEl.classList.remove('hidden');
      }

      if (window.location.href.includes('collections')) {
        canProceedToCheckout();
      }

    } catch (err) {
      const safeMsg = err && err.message ? err.message : String(err || 'An unexpected error occurred');
      console.error('Error verifying email:', safeMsg);
      if (errorElement) {
        errorElement.textContent = safeMsg;
        errorElement.classList.remove('hidden');
      }
    }
  });
}


// close 

function closeEmailVerifyPopup() {
  const popup = document.getElementById('email_verify_popup');
  if (popup) {
    popup.classList.add('hidden');
    document.body.style.overflow = '';
    errorElement.textContent = '';
    successElement.textContent = '';
    errorElement.classList.add('hidden');
    successElement.classList.add('hidden');
    codeInputs.forEach(input => input.value = '');

  }
}
